import { Hairline } from '@doist/marketist'

export function Separator() {
    return <Hairline style={{ margin: 'var(--space-64) auto', width: '100%' }} />
}
